import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 w-full h-16 bg-white" }
const _hoisted_2 = { class: "flex flex-nowrap h-full px-8 mx-auto border-b border-solid border-brand-gray-1" }
const _hoisted_3 = { class: "h-full ml-12" }
const _hoisted_4 = { class: "flex h-full p-0 m-0 list-none" }
const _hoisted_5 = { class: "flex items-center h-full ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProfileImage = _resolveComponent("ProfileImage")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_SubNav = _resolveComponent("SubNav")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(['w-full', 'text-sm', _ctx.headerHeightClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center h-full text-xl text-gray-700 pb-0.5"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Google Careers")
          ]),
          _: 1
        }),
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: menuItem.text,
                class: "h-full ml-9 first:ml-0",
                "data-test": "main-nav-list-item"
              }, [
                _createVNode(_component_router_link, {
                  to: menuItem.url,
                  class: "flex items-center h-full py-2.5 text-gray-700 hover:text-gray-950"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(menuItem.text), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_ProfileImage, {
                key: 0,
                "data-test": "profile-image"
              }))
            : (_openBlock(), _createBlock(_component_ActionButton, {
                key: 1,
                text: "Sign in",
                type: "primary",
                "data-test": "login-button",
                onClick: _ctx.LOGIN_USER
              }, null, 8, ["onClick"]))
        ])
      ]),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_SubNav, {
            key: 0,
            "data-test": "subnav"
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}